/** GOVOPS-1301 — shared fee/payment field helpers for forms ↔ GovOps API. */

export const PAYMENT_STATUS_OPTIONS = ['unpaid', 'pending', 'paid', 'overdue'];

export function parseFeeNumber(value) {
  if (value === '' || value === null || value === undefined) return undefined;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : undefined;
}

export function defaultFeeFields() {
  return {
    feeAmount: '',
    feeCurrency: 'USD',
    balanceDue: '',
    paymentStatus: 'unpaid',
    renewalDate: '',
    expirationDate: '',
    checkNumber: '',
  };
}

/** Copy fee fields from permit or form onto a plain object for create/update payloads. */
export function pickFeeFields(source = {}) {
  const feeAmount = parseFeeNumber(source.feeAmount);
  const balanceDue = parseFeeNumber(source.balanceDue);
  const out = {};
  if (feeAmount !== undefined) out.feeAmount = feeAmount;
  if (source.feeCurrency) out.feeCurrency = String(source.feeCurrency).trim() || 'USD';
  if (balanceDue !== undefined) out.balanceDue = balanceDue;
  else if (feeAmount !== undefined && source.paymentStatus === 'paid') out.balanceDue = 0;
  else if (feeAmount !== undefined && source.balanceDue === '' && source.paymentStatus === 'unpaid') {
    out.balanceDue = feeAmount;
  }
  if (source.paymentStatus && PAYMENT_STATUS_OPTIONS.includes(source.paymentStatus)) {
    out.paymentStatus = source.paymentStatus;
  }
  if (source.renewalDate) out.renewalDate = String(source.renewalDate).slice(0, 10);
  if (source.expirationDate) out.expirationDate = String(source.expirationDate).slice(0, 10);
  if (source.checkNumber) out.checkNumber = source.checkNumber;
  return out;
}
